<template>
    <modal-controller-base contentClass="light-gradient-background">
        <template #header>
            <filter-header :title="$t('object.setting')" @back="modalController.dismiss()" />
        </template>
        <ion-accordion-group class="px-1 pb-1">
            <ion-accordion class="my-1 setting-border grey4-light-background">
                <ion-item
                    slot="header"
                    lines="none"
                    class="grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle"
                >
                    <div slot="start" class="icon-width">
                        <ion-icon class="purple-purple-color px-1 fs-30" src="assets/icon/filter.svg" />
                    </div>
                    <div class="purple-purple-color">
                        {{ $t('titleRoute.filter') }}
                    </div>
                </ion-item>

                <div slot="content" class="light-light-background">
                    <!-- TODO: Ask what problem here was since implemented solution doesn't work for web version-->
                    <filter-interface
                        style="height: clamp(350px, calc(100vh - 330px), 550px)"
                        v-model:tempCategory="tempCategory"
                        v-model:tempTags="tempTags"
                        v-model:withQuantity="withQuantity"
                        v-model:sort-direction="tempSortDirection"
                        :own-categories="listStore.recommendedTags?.data"
                        @reset="resetChanges"
                        @apply="applyChanges"
                        :supplier-id="supplierId"
                        is-list
                    />
                </div>
            </ion-accordion>

            <ion-accordion class="mt-1 setting-border light-light-background">
                <ion-item
                    slot="header"
                    lines="none"
                    class="grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle accordion-toggle-click"
                >
                    <div slot="start" class="icon-width">
                        <ion-toggle
                            :color="ION_VARIANT.CORAL"
                            @click="$event.stopPropagation()"
                            @ion-change="changeDeleteMode"
                            :key="forceReload"
                            :checked="list?.shouldDelete ?? true"
                            class="accordion-toggle px-1 mr-2"
                            slot="start"
                        />
                    </div>
                    <div class="purple-purple-color">
                        {{ $t('label.resetAmount') }}
                    </div>
                </ion-item>

                <div slot="content" class="px-3 pb-3 pt-1 purple-purple-color light-light-background">
                    {{ $t('label.resetProductQuantity') }}
                    <div class="center-x pt-3">
                        <button-base @click="resetListCheck">
                            {{ $t('button.resetAmount') }}
                        </button-base>
                    </div>
                </div>
            </ion-accordion>

            <ion-accordion
                class="my-1 setting-border grey4-light-background"
                v-if="userStore.permission[PERMISSION_KEY.LIST_REMINDER_READ] && !persistentStore.offlineMode"
            >
                <ion-item
                    slot="header"
                    lines="none"
                    class="grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle"
                >
                    <div slot="start" class="icon-width">
                        <ion-icon class="purple-purple-color px-1 fs-30" slot="start" :icon="alarmOutline" />
                    </div>
                    <ion-text class="purple-purple-color">
                        {{ $t('titleRoute.orderNotificationTimer') }}
                    </ion-text>
                </ion-item>

                <div slot="content">
                    <order-notification-timer
					class="custom-order-wecker"
                        no-title
                        style="min-height: 350px; height: calc(100vh - 330px)"
                    />
                </div>
            </ion-accordion>

            <ion-accordion
                v-if="isApp()"
                class="mt-1 setting-border light-light-background"
            >
                <ion-item
                    slot="header"
                    lines="none"
                    class="grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle accordion-toggle-click"
                >
                    <div slot="start" class="icon-width">
                        <ion-toggle
                            :color="ION_VARIANT.CORAL"
                            @click="$event.stopPropagation()"
                            @ion-change="toggleOfflineMode"
                            :key="forceReload"
                            :checked="persistentStore.offlineMode"
                            class="accordion-toggle px-1 mr-2"
                            slot="start"
                        />
                    </div>
                    <ion-text class="purple-purple-color">{{ $t('label.offlineMode') }}</ion-text>
                </ion-item>

                <div slot="content" class="px-3 pb-3 pt-1 purple-purple-color light-light-background">
                    {{ $t('label.offlineMode1') }} <br>
                    {{ $t('label.offlineMode2') }}
                </div>
            </ion-accordion>

            <!-- <ion-accordion v-if="isApp()" class="mt-1 setting-border light-light-background">
                <ion-item
                    slot="header"
                    lines="none"
                    class="grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle accordion-toggle-click"
                >
                    <div slot="start" class="icon-width">
                        <ion-toggle
                            :color="ION_VARIANT.CORAL"
                            @click.stop
                            @ionChange="toggleReducedListDesign"
                            :key="forceReload"
                            :checked="persistentStore?.isReducedList ?? false"
                            class="accordion-toggle px-1 mr-2"
                            slot="start"
                        />
                    </div>
                    <ion-text class="purple-purple-color">{{ $t('label.reducedListDesign') }}</ion-text>
                </ion-item>

                <div slot="content" class="px-3 pb-3 pt-1 purple-purple-color light-light-background">
                    {{ $t('label.reducedListDesignDescription') }}
                </div>
            </ion-accordion> -->
        </ion-accordion-group>
    </modal-controller-base>
</template>

<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import {
    IonAccordion,
    IonAccordionGroup,
    IonIcon,
    IonItem,
    IonToggle,
    loadingController,
    modalController
} from "@ionic/vue";
import { nextTick, onMounted } from "vue";
import router, { route } from "@/router";
import { t } from "@/plugins/vue-i18n";
import { pingRequest } from "@/api-connectors/basicRequests";
import { IonToggleCustomEvent, ToggleChangeEventDetail } from "@ionic/core";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import OrderNotificationTimer from "@/components/popover/OrderNotificationTimer.vue";
import FilterHeader from "@/components/modal/FilterHeader.vue";
import FilterInterface from "@/components/modal/FilterInterface.vue";

import { useUserStore } from "@/stores/user";
import { usePersistentStore } from "@/stores/persistent";
import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { useAlert } from "@/composables/useAlert";
import { useLoader } from "@/composables/useLoader";
import { useCatalogFilter } from "@/composables/viewFunctions/useCatalogFilter";

import { isApp } from "@/functions/enviroment";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { PERMISSION_KEY } from "@/types/user";
import { GetListItemsParams } from "@/types/list";
import { SORT_METHOD } from "@/types/enum/propEnum";

import { alarmOutline } from "ionicons/icons";
import ButtonBase from "@/components/button/ButtonBase.vue";
import * as repl from "repl";
import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";

const props = defineProps<{ supplierId: string }>()

const userStore = useUserStore()
const persistentStore = usePersistentStore()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const { showLoading, hideLoading } = useLoader()

const tempCategory = _ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.category)))
const tempTags = _ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.tags)))
const tempSortDirection = _ref<SORT_METHOD>(listStore.listFilter.sortDirection)
const withQuantity = _ref<boolean>(JSON.parse(JSON.stringify(listStore.listFilter.withQuantity)))
let forceReload = _ref<number>(0)

const listId = _computed<string>(() => route.value.params.listId as string)
const locationId = _computed<string>(() => route.value.params.locationId as string)
const list = _computed(() => listStore.listById(listId.value))

const { getCatalogItems } = useCatalogFilter(listId.value)

const resetChanges = async (): Promise<void> => {
    if (!listId.value) {
        supplierStore.catalogFilter.sortDirection = SORT_METHOD.ALPH_ASC
    } else {
        listStore.listFilter.sortDirection = SORT_METHOD.MANUAL
    }
    listStore.listFilter.category = {}
    listStore.listFilter.tags = {}
    listStore.listFilter.withQuantity = false

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
    if (await loadingController.getTop()) hideLoading()
    if (await modalController.getTop()) modalController.dismiss()
}

const applyChanges = async (): Promise<void> => {
    listStore.listFilter.sortDirection = tempSortDirection.value
    listStore.listFilter.tags = tempTags.value
    listStore.listFilter.category = tempCategory.value
    listStore.listFilter.withQuantity = withQuantity.value

    if (!isApp()) {
        await modalController.dismiss()
        if (tempSortDirection.value === SORT_METHOD.MANUAL) await listStore.getManualSortList(listId.value)
        return
    }

    await showLoading()
    if (tempSortDirection.value === SORT_METHOD.MANUAL) await listStore.getManualSortList(listId.value)
    await getCatalogItems(props.supplierId, undefined, true)
    await listStore.getListItems(new GetListItemsParams({
        locationId: locationId.value,
        listId: listId.value,
        searchKey: supplierStore.searchQuery !== '' ? supplierStore.searchQuery : undefined,
        // category: listStore.activeCategoriesIds.length !== 0 ? listStore.listFilter.category : undefined,
        tags: listStore.activeFiltersIds.length !== 0 ? listStore.activeFiltersIds.join(',') : undefined,
        withQuantity: listStore.listFilter.withQuantity,
        sortField: (supplierStore.sortDesc) ? 'name' : undefined,
        sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC)
    }))
    if (await loadingController.getTop()) hideLoading()
    if (await modalController.getTop()) modalController.dismiss()
}

const loadListContent = async (): Promise<void> => {
    await Promise.all([
        supplierStore.getLocationSupplier(locationId.value),
        listStore.getListItems(new GetListItemsParams({
            locationId: locationId.value,
            listId: listId.value,
            searchKey: supplierStore.searchQuery !== '' ? supplierStore.searchQuery : undefined,
            // category: listStore.listFilter.category !== '' ? listStore.listFilter.category : undefined,
            tags: listStore.activeFiltersIds.length !== 0 ? listStore.activeFiltersIds.join(',') : undefined,
            withQuantity: listStore.listFilter.withQuantity,
            sortField: (supplierStore.sortDesc) ? 'name' : undefined,
            sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC)
        }))
    ])
    listStore.isLoaded.listItems = true

    await supplierStore.getLocationSupplier(locationId.value)

    await supplierStore.getCatalog({
        locationId: locationId.value,
        supplierId: props.supplierId ?? '',
    })
    supplierStore.isLoaded.catalog = true
}

const alertNoInternet = useAlert({
    header: t('alert.discardFormTitle'),
    message: t('alert.noInternet'),
    buttons: [{
        text: t('button.discardChanges'),
        handler: () => {
            supplierStore.isLoaded.catalog = false
            listStore.isLoaded.listItems = false
            loadListContent()
            persistentStore.offlineCache.deleteItem = []
            persistentStore.offlineCache.addItem = []
            persistentStore.offlineCache.patchItem = []
            persistentStore.offlineMode = false
            forceReload.value++
        }
    },
        {
            text: t('button.ok'),
            handler: () => {
                supplierStore.isLoaded.catalog = true
                listStore.isLoaded.listItems = true
                persistentStore.offlineMode = true
                forceReload.value++
            }
        }]
})

const changeDeleteMode = (event: IonToggleCustomEvent<ToggleChangeEventDetail>): void => {
    if (!list.value) return
    list.value.shouldDelete = event.detail.checked

    listStore.editList(list.value)
}

const toggleOfflineMode = async (event: IonToggleCustomEvent<ToggleChangeEventDetail>): Promise<void> => {
    persistentStore.offlineMode = event.detail.checked
    await showLoading(t('alert.syncing'))
    supplierStore.isLoaded.catalog = false
    listStore.isLoaded.listItems = false
    if (persistentStore.offlineMode) {
        if (!await pingRequest()) {
            persistentStore.offlineMode = false
            return
        }

        await Promise.all([
            listStore.getListItems(new GetListItemsParams({
                locationId: locationId.value,
                listId: listId.value,
                searchKey: undefined,
                category: undefined,
                tags: undefined,
                withQuantity: false,
                sortField: (supplierStore.sortDesc) ? 'name' : undefined,
                sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC),
                take: 0
            })),
            supplierStore.getSupplierCategories(locationId.value, props.supplierId),
            listStore.getTags(locationId.value)
        ])

        persistentStore.offlineModeRoute = router.currentRoute.value.fullPath
        await hideLoading()
        listStore.isLoaded.listItems = true

        await supplierStore.getCatalog({
            locationId: locationId.value,
            supplierId: props.supplierId,
            includeList: listId.value,
            take: 0
        })
    } else {
        let jobFailed = false
        for (const item of persistentStore.offlineCache.deleteItem) {
            if (item.itemId.startsWith('new')) continue
            const response = await listStore.deleteItem(item.locationId, item.listId, item.itemId)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        for (const item of persistentStore.offlineCache.addItem) {
            const response = await listStore.addListItem(item.locationId, item.listId, item.supplierItemId ?? '', item.amount ?? 0)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        for (const item of persistentStore.offlineCache.patchItem) {
            const response = await listStore.patchListItem(item.locationId, item.listId, item.itemId, item.amount ?? 0, item.targetStock ?? 0)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        if (jobFailed) return alertNoInternet.present()

        supplierStore.isLoaded.catalog = false
        listStore.isLoaded.listItems = false
        persistentStore.offlineCache.deleteItem = []
        persistentStore.offlineCache.addItem = []
        persistentStore.offlineCache.patchItem = []

        await loadListContent()
    }

    nextTick(() => {
        supplierStore.isLoaded.catalog = true
        listStore.isLoaded.listItems = true
    })

    await hideLoading()
}

const toggleReducedListDesign = (): void => {
    if (!list.value) return

    persistentStore.handleReducedDesign()
}

const resetList = async () => {
    const result = await listStore.resetListItems(locationId.value, listId.value)
    if (!result) return

    await listStore.getListItems(new GetListItemsParams({
        locationId: locationId.value,
        listId: listId.value,
        searchKey: listStore.searchQuery,
        manualSort: listStore.listFilter.sortDirection === SORT_METHOD.MANUAL
    }))

    window.dispatchEvent(new Event('reset-amount'))

    replaceToast({
        message: t('messages.list.amountReset'),
        id: 'amount-reset'
    })
}

const resetListCheck = () => {
    popAlertConfirm({
        message: t('messages.list.resetCheck'),
        handler: {
            ok: resetList
        }
    })
}

onMounted(() => {
    if (usePersistentStore().offlineMode) return
    if (props.supplierId) supplierStore.getSupplierCategories(locationId.value, props.supplierId)
    listStore.getTags(locationId.value)
})
</script>

<style scoped>
.setting-border {
    border-radius: 10px;
}

.accordion-toggle::part(track) {
    --background: var(--ion-color-grey4);
}

.icon-width {
    width: 50px;
}
</style>

<style>
.accordion-toggle-click::part(native) {
    pointer-events: none;
}

.accordion-toggle-click > div[slot=start] {
    pointer-events: auto;
}

.custom-order-wecker::part(scroll) {
	overscroll-behavior-y: auto !important;
}

@media (orientation: landscape) and (min-height: 500px) {
    .custom-order-wecker {
		height: calc(80vh - 160px) !important;
	}
}

@media (min-width: 500px) and (min-height: 500px) {
    .custom-order-wecker {
		height: calc(80vh - 160px) !important;
	}
}
</style>
